import { render, staticRenderFns } from "./TheWalletSideMenu.vue?vue&type=template&id=6c2b0335&"
import script from "./TheWalletSideMenu.vue?vue&type=script&lang=js&"
export * from "./TheWalletSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./TheWalletSideMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports